// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2gjOi","upload":"Small_upload__1jSYT","imageWrap":"Small_imageWrap__FHKQ-","removeBtn":"Small_removeBtn__16XFn"};